import { render, staticRenderFns } from "./InstagramTable.vue?vue&type=template&id=74a97d7d"
import script from "./InstagramTable.vue?vue&type=script&lang=js"
export * from "./InstagramTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports